import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagFacade } from '../../services/feature-flag.facade';
import { take } from 'rxjs';
import { FeatureFlagEnum } from '../../models/feature-flag.model';

@Directive({
  selector: '[rxApplicationsFeatureFlag]',
  standalone: true,
})
export class FeatureFlagDirective {
  #viewContainer: ViewContainerRef = inject(ViewContainerRef);
  #templateRef: TemplateRef<any> = inject(TemplateRef);
  #featureFlagFacade: FeatureFlagFacade = inject(FeatureFlagFacade);

  @Input() set rxApplicationsFeatureFlag({
    flag,
    showWhenDisabled = false,
  }: {
    flag: FeatureFlagEnum;
    showWhenDisabled?: boolean;
  }) {
    if (flag) {
      this.#viewContainer.clear();
      this.#featureFlagFacade
        .isFeatureFlagEnabled$(flag)
        .pipe(take(1))
        .subscribe((isEnabled: boolean) => {
          if ((!isEnabled && showWhenDisabled) || (isEnabled && !showWhenDisabled)) {
            this.#viewContainer.createEmbeddedView(this.#templateRef);
          }
        });
    } else {
      this.#viewContainer.createEmbeddedView(this.#templateRef);
    }
  }
}
